import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {  fetchData, handleUpdateItem } from "../../utils/data";
import {  SiteSettings } from "../../types";
import i18n from "../../i18n";
const lang = i18n.language === "ar" ? "ar" : "en";
export const fetchSetting = createAsyncThunk("get/Setting", async () => {
    const data = await fetchData(`Setting/getSetting?lang=${lang}`);
    return data;
});

export const updateSetting = createAsyncThunk("PUT/Setting", async ({ data }: { data: any }) => {
    await handleUpdateItem(data, `Setting/editSetting`, "PUT");
    return { ...data };
});

interface SettingState {
    siteInfo: SiteSettings|null;
    loading: boolean;
    error: string;
}

const initialState: SettingState = {
    siteInfo: null,
    loading: false,
    error: ""
};

const settingSlice = createSlice({
    name: "settingSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchSetting.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchSetting.fulfilled, (state, action) => {
                state.loading = false;
                state.siteInfo = action.payload;
            })
            // Update
            .addCase(updateSetting.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(updateSetting.fulfilled, (state, action) => {
                state.loading = false;
                state.siteInfo = action.payload;
            })
        }
});

export default settingSlice.reducer;
